

let currentProduct = null;
let selectedOptions = {};

function setQuickViewLoading(button, isLoading) {
    if (!button) return;
    button.classList.toggle('is-loading', Boolean(isLoading));
    button.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    if (isLoading) {
        button.setAttribute('disabled', 'disabled');
    } else {
        button.removeAttribute('disabled');
    }

    const imageMask = button.closest('.grid-product__image-mask');
    if (imageMask) {
        imageMask.classList.toggle('is-quick-add-loading', Boolean(isLoading));
    }
}

function formatPrice(cents) {
    const value = Number(cents || 0) / 100;
    return value.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}

function updateCompareAtPrice(compareAtPriceEl, compareAtCents, priceCents) {
    if (!compareAtPriceEl) return;

    const compareValue = Number(compareAtCents || 0);
    const priceValue = Number(priceCents || 0);
    const shouldShow = compareValue > 0 && compareValue > priceValue;

    if (shouldShow) {
        compareAtPriceEl.innerText = '$' + formatPrice(compareValue);
        compareAtPriceEl.style.display = '';
        return;
    }

    compareAtPriceEl.innerText = '';
    compareAtPriceEl.style.display = 'none';
}

function getSelectedVariant() {
    if (!currentProduct || !Array.isArray(currentProduct.variants)) return null;

    return currentProduct.variants.find(v =>
        v.option1 === (selectedOptions.option1 || null) &&
        v.option2 === (selectedOptions.option2 || null) &&
        v.option3 === (selectedOptions.option3 || null)
    ) || null;
}

function hasSelectableOptions(product) {
    if (!product || !Array.isArray(product.options)) return false;
    return product.options.some((opt) => Array.isArray(opt.values) && opt.values.length > 1);
}

function updateQuickAddLayoutMode(isSimpleMode) {
    const details = document.querySelector('#QuickAddModal .qa-details');
    if (!details) return;
    details.classList.toggle('qa-details--simple', Boolean(isSimpleMode));
}

function updateFullDetailLink(variant = null) {
    const detailLink = document.getElementById('QA-FullDetailLink');
    if (!detailLink || !currentProduct) return;
    let href = `/products/${currentProduct.handle}`;
    if (variant && variant.id) {
        href += `?variant=${variant.id}`;
    }
    detailLink.setAttribute('href', href);
}

function updateSelectedVariantUI() {
    const priceEl = document.getElementById('QA-Price');
    const compareAtPriceEl = document.getElementById('QA-CompareAtPrice');
    const addBtn = document.getElementById('QA-AddButton');
    const errorEl = document.getElementById('QA-Error');
    if (!priceEl || !addBtn) return;

    const variant = getSelectedVariant();

    if (variant) {
        const priceValue = Number(variant.price || 0);
        priceEl.innerText = '$' + formatPrice(priceValue);
        updateCompareAtPrice(compareAtPriceEl, variant.compare_at_price, priceValue);
        addBtn.disabled = !variant.available;
        addBtn.innerText = variant.available ? 'ADD TO CART' : 'SOLD OUT';
    } else {
        const priceValue = Number(currentProduct?.price || 0);
        priceEl.innerText = '$' + formatPrice(priceValue);
        updateCompareAtPrice(compareAtPriceEl, currentProduct?.compare_at_price, priceValue);
        addBtn.disabled = true;
        addBtn.innerText = 'UNAVAILABLE';
    }
    updateFullDetailLink(variant);

    if (errorEl) {
        errorEl.style.display = 'none';
    }
}

// 1. 打开弹窗
async function openQuickAdd(productHandle) {
    const modal = document.getElementById('QuickAddModal');
    try {
        const response = await fetch(`/products/${productHandle}.js`);
        if (!response.ok) {
            throw new Error('Failed to load product.');
        }
        currentProduct = await response.json();

        // 渲染多图滑动
        renderSlider(currentProduct.images || []);

        document.getElementById('QA-Title').innerText = currentProduct.title;

        // 渲染多属性逻辑
        renderOptions();
        updateSelectedVariantUI();

        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    } catch (err) {
        console.error("Quick Add Error:", err);
    }
}
function moveSlider(direction) {
    const slider = document.getElementById('QA-Image-Slider');
    const scrollAmount = slider.offsetWidth;
    slider.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth'
    });
}
function renderSlider(images) {
    const slider = document.getElementById('QA-Image-Slider');
    const dots = document.getElementById('QA-Slider-Dots');
    const prevBtn = document.querySelector('.qa-nav-btn.prev');
    const nextBtn = document.querySelector('.qa-nav-btn.next');

    slider.innerHTML = images.map(img => {
        // 1. 去掉可能存在的尺寸后缀，获取原始路径
        const baseImg = img.replace(/_(?:\d+x\d*|\d*x\d+)(?:_crop_\w+)?(?=\.(?:jpg|jpeg|gif|png|webp))/i, '');
        
        // 2. 生成不同尺寸的 URL (例如 400px, 800px, 1200px)
        const src400 = getSizedImageUrl(baseImg, '400x');
        const src800 = getSizedImageUrl(baseImg, '800x');
        const src1200 = getSizedImageUrl(baseImg, '1200x');

        return `
            <img 
                src="${src800}" 
                srcset="${src400} 400w, ${src800} 800w, ${src1200} 1200w"
                sizes="(max-width: 767px) 100vw, 400px"
                loading="lazy"
                alt="Product Image"
            >
        `;
    }).join('');

    if (images.length > 1) {
        // 激活箭头
        prevBtn.classList.add('active');
        nextBtn.classList.add('active');
        
        dots.innerHTML = images.map((_, i) => `<div class="qa-dot ${i === 0 ? 'active' : ''}"></div>`).join('');

        slider.onscroll = () => {
            const index = Math.round(slider.scrollLeft / slider.offsetWidth);
            dots.querySelectorAll('.qa-dot').forEach((dot, i) => {
                dot.classList.toggle('active', i === index);
            });
            
            // 可选：根据位置隐藏首尾箭头
            prevBtn.style.opacity = slider.scrollLeft < 10 ? "0.3" : "1";
            nextBtn.style.opacity = (slider.scrollLeft + slider.offsetWidth) >= slider.scrollWidth - 10 ? "0.3" : "1";
        };
    } else {
        dots.innerHTML = '';
        prevBtn.classList.remove('active');
        nextBtn.classList.remove('active');
    }
}
function getSizedImageUrl(src, size) {
    if (!src) return '';
    if (size === 'master') return src;
    
    // 在扩展名前插入尺寸，例如 test.jpg -> test_400x.jpg
    const match = src.match(/\.(jpg|jpeg|gif|png|webp)/i);
    if (match) {
        const extension = match[0];
        return src.replace(extension, `_${size}${extension}`);
    }
    return src;
}
// 2. 渲染选项（增加 Default Title 屏蔽）
function renderOptions() {
    const container = document.getElementById('QA-Variants');
    container.innerHTML = '';
    selectedOptions = {};

    const simpleMode = !hasSelectableOptions(currentProduct);
    updateQuickAddLayoutMode(simpleMode);

    // 无可选属性：隐藏选项区，直接使用默认变体
    if (simpleMode) {
        container.style.display = 'none';
        const defaultVariant = currentProduct.variants && currentProduct.variants[0] ? currentProduct.variants[0] : null;
        selectedOptions.option1 = defaultVariant ? defaultVariant.option1 : null;
        selectedOptions.option2 = defaultVariant ? defaultVariant.option2 : null;
        selectedOptions.option3 = defaultVariant ? defaultVariant.option3 : null;
        return;
    }

    container.style.display = 'block';

    currentProduct.options.forEach((option, index) => {
        selectedOptions[`option${index + 1}`] = option.values[0];

        const optionDiv = document.createElement('div');
        optionDiv.innerHTML = `
        <p class="variant-option-title">${option.name}</p>
        <div class="variant-chips" data-option-index="option${index + 1}">
          ${option.values.map(val => `
            <div class="chip ${val === option.values[0] ? 'selected' : ''}" 
                 onclick="selectOption('option${index + 1}', '${val.replace(/'/g, "\\'")}', this)">
              ${val}
            </div>
          `).join('')}
        </div>
      `;
        container.appendChild(optionDiv);
    });
}

// 3. 选中逻辑
function selectOption(optIndex, value, el) {
    selectedOptions[optIndex] = value;

    // 切换 UI 状态
    el.parentElement.querySelectorAll('.chip').forEach(c => c.classList.remove('selected'));
    el.classList.add('selected');

    updateSelectedVariantUI();
}

// 4. 加入购物车动作
async function handleAddToCart() {
    const btn = document.getElementById('QA-AddButton');
    const errorEl = document.getElementById('QA-Error');
    const variant = getSelectedVariant();
    if (!btn || !errorEl) return;
    if (typeof window.gtag === 'function') {
        window.gtag('event', 'quick_atc_click');
    }
    if (!variant) {
        errorEl.innerText = 'Please select an available variant.';
        errorEl.style.display = 'block';
        btn.disabled = false;
        btn.innerText = 'ADD TO CART';
        return;
    }
    if (!variant.available) {
        errorEl.innerText = 'This variant is sold out.';
        errorEl.style.display = 'block';
        btn.disabled = true;
        btn.innerText = 'SOLD OUT';
        return;
    }

    btn.disabled = true;
    btn.innerText = 'ADDING...';
    errorEl.style.display = 'none';

    try {
        const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
        });

        if (res.ok) {
            document.documentElement.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
            btn.innerText = 'ADDED';
            setTimeout(() => {
                closeQuickAdd();
                updateSelectedVariantUI();
            }, 300);
        } else {
            const data = await res.json();
            throw new Error(data.description || data.message || 'Add to cart failed');
        }
    } catch (err) {
        errorEl.innerText = err.message;
        errorEl.style.display = 'block';
        btn.disabled = false;
        btn.innerText = 'ADD TO CART';
    }
}

function closeQuickAdd() {
    document.getElementById('QuickAddModal').setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
}

function initQuickAddEvents() {
    document.querySelectorAll('.quick-add-trigger').forEach((trigger) => {
        trigger.setAttribute('data-quick-add-ready', 'true');
        trigger.removeAttribute('aria-disabled');
    });

    document.body.addEventListener('click', (e) => {
        const trigger = e.target.closest('.quick-add-trigger');
        if (trigger) {
            e.preventDefault(); // 防止  标签跳转
            e.stopPropagation();
            if (typeof e.stopImmediatePropagation === 'function') {
                e.stopImmediatePropagation();
            }
            if (trigger.classList.contains('is-loading')) {
                return;
            }
            const handle = trigger.getAttribute('data-handle');
            if (handle) {
                setQuickViewLoading(trigger, true);
                if (typeof window.gtag === 'function') {
                    window.gtag('event', 'quick_view_click');
                }
                openQuickAdd(handle).finally(() => {
                    setQuickViewLoading(trigger, false);
                });
            }
        }
    }, true);
}

// 如果页面已经加载完成，直接运行；否则等待加载完成
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickAddEvents);
} else {
    initQuickAddEvents();
}
